//@flow
import type {BlogAuthor} from '../../../entities';
import {getAuthorApi, listAuthorsApi} from '../api/blog-authors';

export function getAuthorListService(): Promise<BlogAuthor[]> {
  return listAuthorsApi().toPromise();
}

export function getAuthorService(authorId: string): Promise<BlogAuthor> {
  return getAuthorApi({
    blog_author_id: authorId,
  }).toPromise();
}
